export default "__VITE_ASSET__DdvQ2RKi__"